import ReactEChartsCoreImport from "echarts-for-react/lib/core";
import type { EChartsType } from "echarts/core";

const ReactEChartsCore = ((ReactEChartsCoreImport as unknown as { default?: typeof ReactEChartsCoreImport }).default ?? ReactEChartsCoreImport) as typeof ReactEChartsCoreImport;
import * as echarts from "echarts/core";
import { BarChart, LineChart } from "echarts/charts";
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  ToolboxComponent,
  TooltipComponent
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  BarChart,
  LineChart,
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  ToolboxComponent,
  TooltipComponent,
  CanvasRenderer
]);

export function Chart({
  option,
  style,
  notMerge = false,
  replaceMerge,
  onEvents,
  onChartReady
}: {
  option: unknown;
  style?: React.CSSProperties;
  notMerge?: boolean;
  replaceMerge?: string | string[];
  onEvents?: Record<string, (params: unknown) => void>;
  onChartReady?: (instance: EChartsType) => void;
}) {
  return <ReactEChartsCore echarts={echarts} option={option} style={style} notMerge={notMerge} replaceMerge={replaceMerge} onEvents={onEvents} onChartReady={onChartReady} opts={{ renderer: "canvas" }} />;
}
